'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _tslib = require('../../_virtual/_tslib.js');
var jsxRuntime = require('react/jsx-runtime');
var React = require('react');

var SvgChevronRight = function (props, ref) { return (jsxRuntime.jsx("svg", _tslib.__assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref }, props, { children: jsxRuntime.jsx("path", { d: "M8.626 3.045c-.206.109-.48.388-.588.599a.795.795 0 0 0 .001.719c.063.126 1.167 1.257 3.814 3.907L15.579 12l-3.726 3.73c-2.647 2.65-3.751 3.781-3.814 3.907-.176.353-.087.718.26 1.064.346.347.711.436 1.064.26.252-.127 8.471-8.337 8.597-8.59a.828.828 0 0 0 0-.742c-.122-.245-8.344-8.463-8.588-8.585a.884.884 0 0 0-.746.001", fillRule: "evenodd", fill: "currentColor" }) }))); };
var ForwardRef = React.forwardRef(SvgChevronRight);

exports["default"] = ForwardRef;
//# sourceMappingURL=ChevronRight.js.map
